import React from 'react';
import {
  AiPlanRecommendationBanner,
  type AiBannerSlot,
} from './AiPlanRecommendationBanner';
import { useAiBannerTitle } from './useAiBannerTitle';

interface AiPlanRecommendationBannerDummyProps {
  placement: AiBannerSlot;
}

export const AiPlanRecommendationBannerDummy = ({
  placement,
}: AiPlanRecommendationBannerDummyProps) => {
  const title = useAiBannerTitle();

  return (
    <AiPlanRecommendationBanner title={title} placement={placement} isDummy />
  );
};
